'use strict';

import { FieldType } from '../../../../../../models/form/fieldType';

export default {
  toolbox: {
    fields: {
      [FieldType.Text]: 'Texte',
      [FieldType.LongText]: 'Texte long',
      [FieldType.StaticText]: 'Texte statique',
      [FieldType.Datetime]: 'Date & Heure',
      [FieldType.Date]: 'Date',
      [FieldType.Time]: 'Heure',
      [FieldType.Numeric]: 'Numérique',
      [FieldType.Toggle]: 'Interrupteur',
      [FieldType.Birthdate]: "Date d'anniversaire",
      [FieldType.CheckBox]: 'Case à cocher',
      [FieldType.Acknowledgment]: 'Reconnaissance',
      [FieldType.DocumentViewer]: 'Document',
      [FieldType.EmailAddress]: 'E-mail',
      [FieldType.EmbeddedPhoto]: 'Image',
      [FieldType.HTML]: 'HTML',
      [FieldType.OptionList]: "Liste d'options",
      [FieldType.Rating]: 'Note',
      [FieldType.Select]: 'Sélection',
      [FieldType.Signature]: 'Signature',
      [FieldType.Video]: 'Vidéo',
      [FieldType.WebLink]: 'Lien',
      [FieldType.YesNo]: 'Oui/Non/NA',
      [FieldType.PaymentOptionList]: "Liste de d'options de paiement",
      [FieldType.PaymentChoiceList]: 'Liste de choix de paiement',
      [FieldType.Products]: 'Produits',
      [FieldType.UploadFile]: 'Téléversement de fichier',
    },
    list: {
      text: 'Texte',
      toggle: 'Bascule',
      date: 'Date',
      selection: 'Sélection',
      embedded: 'Intégration',
      miscellaneous: 'Divers',
      payment: 'Paiement',
    },
    labels: {
      option: 'Option',
      product: 'Produit',
    },
  },
};
